import React from "react";
import logo from "@/assets/moneylink_logo.svg";

interface Props {
  content: string | React.ReactNode;
  className?: string;
};

export const LoginHeader = ({ content, className = "" }: Props) => {
  return (
    <header className={className}>
      <h1>
        <img src={logo} alt="Web明細管理「MoneyLink（マネーリンク）」" />
      </h1>
      {typeof content === "string" ? (
        <h2>{content}</h2>
      ) : (
        content
      )}
    </header>
  );
};